import "./AllBlogs.scss";
import BlogCard from "./blogcard/BlogCard";
import { Fragment } from "react";

const AllBlogs = ({ blogList }) => {
  return (
    <section className="all_blogs p_top">
      <div className="content_wrap p_bottom">
        {blogList?.length > 0 ? (
          <div className="bi_grid">
            {blogList?.map((data) => {
              return (
                <Fragment key={data?._id}>
                  <BlogCard data={data} />
                </Fragment>
              );
            })}
          </div>
        ) : (
          <p className="text-center">Data not Found...</p>
        )}
      </div>
    </section>
  );
};
export default AllBlogs;
